import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <div className="container" style={{ padding: '100px 0', textAlign: 'center' }}>
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <h1 style={{ fontSize: '6rem', fontWeight: 'bold', color: '#f3b806' }}>404</h1>
                    <h2 style={{ marginBottom: '20px' }}>Oups ! Cette page n'existe pas.</h2>
                    <p style={{ marginBottom: '30px', fontSize: '18px', color: '#666' }}>
                        Il semble que le lien que vous avez suivi soit cassé ou que la page ait été supprimée.
                    </p>
                    <Link to="/" className="btn" style={{
                        backgroundColor: '#f3b806',
                        color: '#fff',
                        padding: '12px 30px',
                        textTransform: 'uppercase',
                        fontWeight: '600',
                        borderRadius: '30px'
                    }}>
                        Retour à l'accueil
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
